import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* ── Brand ── */}
        <div className="footer-brand">
          <span className="footer-brand-name">Casa del Padel</span>
          <span className="footer-brand-sub">Club de padel à Sfax, Tunisie</span>
          <div className="footer-socials">
            <a
              href="https://www.facebook.com/profile.php?id=61559890747854"
              target="_blank"
              rel="noreferrer"
              className="footer-social-btn"
              aria-label="Facebook"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/casa_del_padel"
              target="_blank"
              rel="noreferrer"
              className="footer-social-btn"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* ── Links + Contact ── */}
        <div className="footer-cols">
          <div className="footer-col">
            <span className="footer-col-title">Navigation</span>
            <Link to="/" className="footer-link">Accueil</Link>
            <Link to="/reservation-v2" className="footer-link">Réservation</Link>
            <Link to="/tournois" className="footer-link">Tournois</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>

          <div className="footer-col">
            <span className="footer-col-title">Nous trouver</span>
            <div className="footer-contact-row">
              <FaMapMarkerAlt className="footer-contact-icon" />
              <span>Route Sidi Mansour km 6, Sfax</span>
            </div>
            <div className="footer-contact-row">
              <FaPhone className="footer-contact-icon" />
              <span>58 444 440</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Casa del Padel. Tous droits réservés.</span>
      </div>
    </footer>
  );
};

export default Footer;
